// Custom Theme JavaScript for Pet & Healthcare Store

// Store Selection Management
const stores = {
  eastwood: {
    name: 'Eastwood Store',
    address: '1/1-7 Rowe St, Eastwood NSW 2122',
    hours: 'Mon-Sun: 8:30 AM - 9:30 PM',
    phone: '02 2345 6789',
    id: 'location_eastwood'
  },
  lidcombe: {
    name: 'Lidcombe Store',
    address: 'Level 1, Lidcombe Shopping Centre',
    hours: 'Mon-Sun: 9:00 AM - 9:00 PM',
    phone: '02 3456 7890',
    id: 'location_lidcombe'
  }
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  // Check for saved store preference
  const savedStore = localStorage.getItem('selectedStore');
  if (savedStore && stores[savedStore]) {
    updateSelectedStore(savedStore);
  }
  
  // Initialize cart notification
  initializeCartNotification();
  
  // Add product badges
  addProductBadges();
});

// Store Modal Functions
window.openStoreModal = function() {
  const modal = document.getElementById('storeModal');
  if (modal) {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

window.closeStoreModal = function() {
  const modal = document.getElementById('storeModal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

window.selectStore = function(storeId) {
  // Update UI
  const storeItems = document.querySelectorAll('.store-item');
  storeItems.forEach(item => item.classList.remove('selected'));
  
  // Find and select the clicked item
  if (event && event.currentTarget) {
    event.currentTarget.classList.add('selected');
  }
  
  // Save preference
  localStorage.setItem('selectedStore', storeId);
  
  // Update display
  updateSelectedStore(storeId);
}

function updateSelectedStore(storeId) {
  const store = stores[storeId];
  if (store) {
    const storeName = document.getElementById('selectedStoreName');
    const storeHours = document.getElementById('storeHours');
    
    if (storeName) storeName.textContent = store.name;
    if (storeHours) storeHours.textContent = `Hours: ${store.hours}`;
    
    // Add store to cart attributes
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'pickup_location': store.name,
          'pickup_address': store.address,
          'pickup_location_id': store.id
        }
      })
    }).catch(error => console.log('Cart update error:', error));
  }
}

// Cart Notification System
function initializeCartNotification() {
  // Override Shopify's add to cart
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();
      addToCartWithNotification(form);
    }
  });
}

function addToCartWithNotification(form) {
  const formData = new FormData(form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    showCartNotification(data);
    updateCartCount();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    // Submit form normally if there's an error
    form.submit();
  });
}

function showCartNotification(product) {
  // Remove existing notification
  const existing = document.querySelector('.cart-notification');
  if (existing) existing.remove();
  
  const notification = document.createElement('div');
  notification.className = 'cart-notification active';
  notification.innerHTML = `
    <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 15px;">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="#16A34A">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
      </svg>
      <div>
        <p style="font-weight: bold; margin: 0; color: #111827;">Item added to cart</p>
        <p style="margin: 5px 0 0 0; color: #6B7280; font-size: 14px;">${product.product_title || 'Product'}</p>
      </div>
    </div>
    <div style="display: flex; gap: 10px;">
      <button onclick="this.closest('.cart-notification').remove()" 
              style="flex: 1; padding: 8px; border: 1px solid #D1D5DB; background: white; border-radius: 4px; cursor: pointer; font-weight: 500;">
        Continue Shopping
      </button>
      <a href="/cart" 
         style="flex: 1; padding: 8px; background: #1E40AF; color: white; text-align: center; text-decoration: none; border-radius: 4px; font-weight: 500;">
        View Cart
      </a>
    </div>
  `;
  
  document.body.appendChild(notification);
  
  // Auto remove after 5 seconds
  setTimeout(() => {
    if (notification && notification.parentNode) {
      notification.remove();
    }
  }, 5000);
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCounts = document.querySelectorAll('.cart-count-bubble');
      cartCounts.forEach(count => {
        count.textContent = cart.item_count;
        if (cart.item_count > 0) {
          count.style.display = 'flex';
        } else {
          count.style.display = 'none';
        }
      });
    })
    .catch(error => console.log('Cart count update error:', error));
}

// Product Badges
function addProductBadges() {
  const products = document.querySelectorAll('.card--standard');
  products.forEach(product => {
    // Skip if already has badge
    if (product.querySelector('.product-badge')) return;
    
    // Check for sale price
    const comparePrice = product.querySelector('.price--on-sale');
    if (comparePrice) {
      const badge = document.createElement('div');
      badge.className = 'product-badge badge-sale';
      badge.textContent = 'SALE';
      badge.style.cssText = 'position: absolute; top: 10px; left: 10px; background: #DC2626; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: bold; z-index: 10;';
      
      const mediaWrapper = product.querySelector('.card__media');
      if (mediaWrapper) {
        mediaWrapper.style.position = 'relative';
        mediaWrapper.appendChild(badge);
      }
    }
  });
}

// Item Request Form
window.showItemRequestForm = function() {
  const modal = document.createElement('div');
  modal.className = 'store-modal active';
  modal.innerHTML = `
    <div class="store-modal-content">
      <h2 style="color: #1E40AF; margin-bottom: 10px;">Request an Item</h2>
      <p style="color: #6B7280; margin-bottom: 20px;">Can't find what you're looking for? Let us know and we'll try to stock it for you.</p>
      
      <form id="itemRequestForm">
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">Product Name *</label>
          <input type="text" name="product_name" required 
                 style="width: 100%; padding: 10px; border: 1px solid #D1D5DB; border-radius: 4px; font-size: 14px;">
        </div>
        
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">Brand (optional)</label>
          <input type="text" name="brand" 
                 style="width: 100%; padding: 10px; border: 1px solid #D1D5DB; border-radius: 4px; font-size: 14px;">
        </div>
        
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">Your Name *</label>
          <input type="text" name="customer_name" required 
                 style="width: 100%; padding: 10px; border: 1px solid #D1D5DB; border-radius: 4px; font-size: 14px;">
        </div>
        
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500;">Email *</label>
          <input type="email" name="email" required 
                 style="width: 100%; padding: 10px; border: 1px solid #D1D5DB; border-radius: 4px; font-size: 14px;">
        </div>
        
        <div style="display: flex; gap: 10px;">
          <button type="button" onclick="this.closest('.store-modal').remove()" 
                  style="flex: 1; padding: 12px; border: 1px solid #D1D5DB; background: white; border-radius: 6px; cursor: pointer; font-weight: 500;">
            Cancel
          </button>
          <button type="submit" 
                  style="flex: 1; padding: 12px; background: #1E40AF; color: white; border: none; border-radius: 6px; cursor: pointer; font-weight: 500;">
            Submit Request
          </button>
        </div>
      </form>
    </div>
  `;
  
  document.body.appendChild(modal);
  
  modal.querySelector('#itemRequestForm').addEventListener('submit', function(e) {
    e.preventDefault();
    
    // Show success message
    modal.innerHTML = `
      <div class="store-modal-content" style="text-align: center;">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="#16A34A" style="margin-bottom: 20px;">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <h2 style="color: #1E40AF; margin-bottom: 10px;">Request Submitted!</h2>
        <p style="color: #6B7280; margin-bottom: 20px;">
          Thank you for your request. We'll review it and contact you within 2-3 business days.
        </p>
        <button onclick="this.closest('.store-modal').remove()" 
                style="padding: 12px 40px; background: #1E40AF; color: white; border: none; border-radius: 6px; cursor: pointer; font-weight: 500;">
          Close
        </button>
      </div>
    `;
    
    setTimeout(() => {
      modal.remove();
    }, 3000);
  });
}